import { c as _c } from "react/compiler-runtime";
import { ComponentProps, ReactNode } from 'react';
import cx from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHashtag } from '@fortawesome/free-solid-svg-icons';
import { Typography } from '../AppTypography';
import './styles.scss';
const {
  Title
} = Typography;
export interface AnchorHeadingProps extends Omit<ComponentProps<typeof Title>, 'children'> {
  /**
   * The ID to use for the heading anchor link
   */
  anchorId: string;
  /**
   * Whether this heading should be highlighted (matches current hash)
   */
  highlighted?: boolean;
  /**
   * The content of the heading
   */
  children: ReactNode;
}

/**
 * A heading component with a clickable hash anchor link
 * Provides consistent styling and behavior for section headings
 */
export function AnchorHeading(t0) {
  const $ = _c(19);
  let anchorId;
  let children;
  let className;
  let highlighted;
  let props;
  if ($[0] !== t0) {
    ({
      anchorId,
      highlighted,
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = anchorId;
    $[2] = children;
    $[3] = className;
    $[4] = highlighted;
    $[5] = props;
  } else {
    anchorId = $[1];
    children = $[2];
    className = $[3];
    highlighted = $[4];
    props = $[5];
  }
  const t1 = highlighted && "app-anchor-heading--highlighted";
  let t2;
  if ($[6] !== className || $[7] !== t1) {
    t2 = cx("app-anchor-heading", t1, className);
    $[6] = className;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const t3 = `#${anchorId}`;
  const t4 = `Link to ${typeof children === "string" ? children : "section"}`;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FontAwesomeIcon icon={faHashtag} />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t4) {
    t6 = <a href={t3} className="app-anchor-heading-link" aria-label={t4} tabIndex={0}>{t5}</a>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== anchorId || $[14] !== children || $[15] !== props || $[16] !== t2 || $[17] !== t6) {
    t7 = <Title {...props} id={anchorId} className={t2}>{children}{t6}</Title>;
    $[13] = anchorId;
    $[14] = children;
    $[15] = props;
    $[16] = t2;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}
export default AnchorHeading;